import { createContext, useContext } from 'react'

export const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

const getBaseUrl = () => {
  const { protocol, hostname } = document.location
  if (process.env.REACT_APP_ENV === 'staging')
    return 'https://staging-api.hydrascore.com'
  if (process.env.REACT_APP_ENV === 'dev')
    return 'https://dev-api.hydrascore.com'
  if (process.env.NODE_ENV === 'production') return 'https://api.hydrascore.com'
  return `${protocol}//${hostname}:4011`
}

const BASE_URL = getBaseUrl()

const apiRequest = async (endpoint, method, body, headers = {}) => {
  const url = `${BASE_URL}${endpoint}`
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  }

  // Only include body for methods that allow it
  if (method !== 'GET' && method !== 'HEAD') {
    options.body = body ? JSON.stringify(body) : null
  }

  const response = await fetch(url, options)
  return response.json()
}

export const parseProfileResponse = (res) => {
  if (!['success', 'no sub'].includes(res.status)) return res
  const now = new Date()
  return {
    status: res.status,
    sessionKey: res.session_key[0],
    name: res.profile['fullname'],
    tier: res.profile['tier'],
    firstname: res.profile['firstname'],
    lastname: res.profile['lastname'],
    email: res.profile['email'],
    notifyHsChange: res.profile['notify_hs_change'],
    firstLogin: res.profile['firstlogin'],
    expiry: now.getTime() + 7200000, // 2 hours
    tutorial: res.profile['tutorial'],
    trial_status: res.profile['trial_status'],
    trial_end_at: res.profile['trial_end_at'],
    iap_platform: res.profile['iap_platform'],
    renewal_date: res.profile['renewal_date'],
    next_phase: res.profile['next_phase'],
  }
}

export async function signIn2(email, password) {
  return apiRequest('/signin2', 'POST', { email, password })
}

export async function signIn(email, password) {
  const res = await apiRequest('/signin', 'POST', { email, password })
  return parseProfileResponse(res)
}

export async function updatePassword(email, password, newPassword) {
  const res = await apiRequest('/update_password', 'POST', {
    email,
    old_password: password,
    password: newPassword,
  })
  return parseProfileResponse(res)
}

export default async function getAuth(email, password, otp) {
  const res = await apiRequest('/twofactorauth', 'POST', {
    email,
    password,
    otp,
  })
  return parseProfileResponse(res)
}

export async function getAdmin(sessionKey) {
  const res = await apiRequest('/get_admin', 'POST', {
    session_key: sessionKey,
  })
  return res.status === 'success' ? res.admin : null
}

export async function getEnterprise(sessionKey) {
  const res = await apiRequest('/get_enterprise_admin', 'GET', null, {
    Authorization: `Bearer ${sessionKey}`,
  })

  if ([400, 401].includes(res.status)) {
    localStorage.removeItem('auth')
    window.location.href = '/sign-in'
    return null
  }

  return res.status === 'success' ? res.admin : null
}

export async function getProfile(sessionKey) {
  return await apiRequest('/get_profile', 'POST', { session_key: sessionKey })
}
